/*
 * @Description:
 */

import { createApp } from 'vue'
import UpdateTips from './update-tips.vue'

let instance

function UpdateTipsPromise(options) {
  return new Promise((resolve) => {
    const app = createApp(UpdateTips, {
      ...options,
      onConfirm: () => {
        resolve(instance)
      }
    })

    const container = document.createElement('div')
    document.body.appendChild(container)

    instance = app.mount(container)

    instance.$remove = () => {
      app.unmount()
      if (document.body.contains(container)) {
        document.body.removeChild(container)
      }
      instance = null
    }
  })
}

export default UpdateTipsPromise
